/* @flow */
/* eslint-env es6,browser */

import * as u from '../utils';
import * as jsonp from '../jsonp';
import bidbase from './bidbase';
import bm from '../bidmanager';

/**
 * @module bidders/sonobi
 */
/**
 * @global
 * @typedef {object} sonobiConfig
 * @description extends {@link hbConfig}
 * @property {string} adUrl
 */
/**
 * @description Implements functionality for Sonobi header bidding
 * @extends _bidbase
 * @requires {@link module:utils}
 * @requires {@link module:jsonp}
 */
class _sonobibid extends bidbase {
  _config: sonobiConfig;
  _DefConfig: sonobiConfig;
  constructor(){
    super('sonobi');
    this._DefConfig = u.extend(true, {}, this._DefConfig, {
      adUrl : ''
    });
    this._config = u.extend(true, {}, this._DefConfig);
    this._mandatoryConfigs = ['bidUrl'];
    this._isSupported = u.isJSONSupported();
  }

  /**
   * Process bid response. Response format:
   * resp.sbi_dc - data center to formulate sonobi hostname
   * resp.slots[pos].sbi_mouse - ecpm value
   * resp.slots[pos].adm - ad creative
   * resp.slots[pos].nurl - impression pixel
   * @param {Array<string>} posList
   * @param {Object} resp
   * @param {Object.<string, hbPosData>} ret
   * @return {Object.<string, hbPosData>}
   * @access private
   */
  _processBidResponse(posList: Array<string>, resp: any, ret: hbPartnerData): hbPartnerData {
    if (!resp || !u.isObject(resp.slots) || !u.isString(resp.sbi_dc) || !resp.sbi_dc.length) {
      return ret;
    }
    posList.forEach(pos => {
      let id = this.getPosKey(pos),
          res = resp.slots[pos];
      if (res && res.sbi_aid && res.sbi_mouse) {
        this._handleBidPosData(ret, pos, res.sbi_mouse, id,
                               `<script type='text/javascript' src='//${resp.sbi_dc}${this._config.adUrl}${res.sbi_aid}'></script>`);
      }
    });
    return ret;
  }

  /**
   * get bids for given positions
   * @param {Array<string>} posList
   * @param {Object.<string, hbPosData>} ret
   * @return {Promise<Object.<string, hbPosData>>}
   * @access private
   */
  _getAds(posList: Array<string>, ret: hbPartnerData): Promise<hbPartnerData> {
    this._bidResponses = {};

    // build params for bid request
    const keyMaker = posList.reduce((o, v) => {
      o[v] = this.getPosKey(v);
      return o;
    }, {});

    let reqParams = {
      data: {
        key_maker: JSON.stringify(keyMaker),
        s: u.getRandom()
      },
      timeout: this._config.timeout,
      jsonp: 'cv',
      logPrefix: posList.join(',')
    };
    return jsonp.JSONP(this._config.bidUrl, reqParams).then(
      data => this._processBidResponse(posList, data, ret),
      msg => { u.logError(`${this._name} Failed to get bids: ${msg || ''}`); return ret; });
  }
}

//add bidder to bidmanager
let sonobibid = new _sonobibid();
bm.addBidder('sonobi', sonobibid);
export default sonobibid;
